import { createApp } from 'vue'
import App from './App.vue'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'
import 'bootstrap-icons/font/bootstrap-icons.css'
import './style.css'
import { NavigationBarColor, NavigationBar } from '@capgo/capacitor-navigation-bar';
import { StatusBar, Style } from '@capacitor/status-bar';
import { Amplify } from 'aws-amplify';
import awsExports from './aws-exports';

// Configure Amplify
Amplify.configure(awsExports);

createApp(App).mount('#app')

if (Capacitor.isNativePlatform()) {
    const data = localStorage.getItem('budgetApp');
    if (data) {
        let parsedData = JSON.parse(data);
        let isDarkMode = parsedData.isDarkMode || false;
        if (isDarkMode) {
            NavigationBar.setNavigationBarColor({ color: NavigationBarColor.BLACK, darkButtons: false });
        } else {
            NavigationBar.setNavigationBarColor({ color: NavigationBarColor.WHITE, darkButtons: true });
        }
    }
}

const setStatusBarStyleDark = async () => {
    await StatusBar.setStyle({ style: Style.Dark });
};
